<template>
  <div class="row recommend-event-news-item-container">
    <div class="recommend-event-news-item-left" :class="{'negative-count': data.sentiment==='负面'}">
      <div class="count">{{data.heat}}</div>
      <img v-if="showIcon" src="../../assets/img/hot.svg" class="lightning-img" alt="">
    </div>
    <div class="recommend-event-news-item-right">
      <router-link target="_blank" :to="{path: '/event-detail', query:{title: data.title, id: data.eventId}}">
        <div class="recommend-event-news-item-right-title">{{data.title}}</div>
      </router-link>
      <div class="recommend-event-news-item-companies">
        <div class="row" v-for="(item, index) in data.monitorCompanies" :key="index">
          <div class="recommend-event-news-item-company" @click="toCompanyDetail(item.name)">{{item.stock_code}}</div>
          <RecommendEventPopover :item="item"></RecommendEventPopover>
          <div></div>
        </div>
        <div v-for="(item, index) in data.relatedCompanies" :key="index+'relation'">
          <div class="row">
            <div class="recommend-event-news-item-company" @click="toCompanyDetail(item.name)">
              <span>{{item.stock_code}}</span>
            </div>
            <ConcernRelatedCompanyPopover :item="item"></ConcernRelatedCompanyPopover>
            <div></div>
          </div>
          <div class="row relation-with-monitor-company">
            <div class="relation-with-monitor-company-item" v-for="(i, idx) in item.related_monitor_company" :key="idx">
              <div>[{{i.monitor_company}}-{{i.relation_with_monitor_company}}]</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row recommend-event-news-item-right-bottom">
        <div>{{data.count}}条相关新闻</div>
        <div class="recommend-event-news-item-right-first-time">首篇报道: {{data.firstTime}}</div>
        <div>最新报道: {{data.lastTime}}</div>
      </div>
    </div>     
  </div>
</template>

<script>
import RecommendEventPopover from '@/components/recommend/RecommendEventPopover';
import ConcernRelatedCompanyPopover from '@/components/concern/ConcernRelatedCompanyPopover';

export default {
  name: 'recommend-event-news-item',
  props: {
    data: {
      type: Object
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  components: {
    RecommendEventPopover,
    ConcernRelatedCompanyPopover
  },
  methods: {
    toEventDetailPage() {
      const routeUrl = this.$router.resolve({
        path: '/event-detail', 
        query: {
          title: this.data.title,
          id: this.data.eventId
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.recommend-event-news-item-container {
  padding: 10px 16px;
  background-color: #ffffff;
  .recommend-event-news-item-left {
    height: 100%;
    width: 45px;
    color: #ff5b65;
    font-size: 14px;
    text-align: center;
    .count:after {
      content: "\00b0"
    }
    .lightning-img {
      width: 16px;
      margin-right: 5px;
    }
  }
  .negative-count {
    color: #36c292;
  }
  .recommend-event-news-item-right {
    margin-left: 4px;
    width: 100%;
    height: 100%;
    .recommend-event-news-item-right-title {
      display: inline-block;
      margin-bottom: 8px;
      color: #171f46;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .recommend-event-news-item-companies {
      .relation-with-monitor-company {
        flex-wrap: wrap;
        .relation-with-monitor-company-item {
          margin-bottom: 4px;
          margin-right: 8px;
          color: #747990;
          font-size: 12px;
        }
      }
      .recommend-event-news-item-company {
        margin: 0 8px 4px 0;
        padding: 0 8px;
        border-radius: 2px;
        border: solid 1px rgba(69, 168, 204, 0.4);
        color: rgba(69, 168, 204, 0.8);
        font-size: 14px;
        cursor: pointer;
        &:hover {
          border: 1px solid #45a8cc;
          color: #45a8cc;
        }
        .recommend-event-news-item-relation {
          color: #9ea1b4;
          font-size: 12px;
        }
      }
    }
    .recommend-event-news-item-right-bottom {
      margin-top: 4px;
      color: #747990;
      font-size: 12px;
      .recommend-event-news-item-right-first-time {
        margin: 0 10px;
      }
    }
  }
}
</style>
